import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormControl } from '@angular/forms';

import { ChartConfiguration, ChartData, ChartEvent } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardContent
} from '@angular/material/card';
import { MatTab, MatTabGroup } from '@angular/material/tabs';

import { Conversation } from '../../../services/conversation';

@Component({
  selector: 'app-category-distribution',
  standalone: true,
  templateUrl: './category-distribution.component.html',
  styleUrls: ['./category-distribution.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    BaseChartDirective,

    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,

    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,

    MatTab,
    MatTabGroup
  ]
})
export class CategoryDistributionComponent implements OnInit {

  @Input() globalStartDate!: Date;
  @Input() globalEndDate!: Date;

  /** Raw table data */
  categoryTable: any[] = [];

  /** Date range */
  startDate = new Date('2025-09-20');
 endDate = new Date('2025-10-06');

  /** Chart.js data */
  barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        label: 'Category Distribution',
        data: []
      }
    ]
  };

  /** Chart.js options */
  barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true
      },
      tooltip: {
        enabled: true
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Conversation Category'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Count'
        },
        beginAtZero: true
      }
    }
  };

  activeTab: 'stats' | 'activity' = 'stats';

  constructor(private conversationService: Conversation) {}

  ngOnInit(): void {
    // Default: last 7 days
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    this.endDate = new Date(); // today
    const start = new Date();
    start.setDate(start.getDate() - 7); // 7 days ago
    this.startDate = start;

    this.fetchCategoryDistribution();
  }

  fetchCategoryDistribution(): void {
    // console.log('here')
    if (!this.startDate || !this.endDate) {
      return;
    }

    

    const start = this.formatDate(this.startDate);
    const end = this.formatDate(this.endDate);
    // console.log(start, end)

    this.conversationService
      .getCategoryDistribution(start, end)
      .subscribe(response => {

        this.categoryTable = response.data ?? [];

        this.barChartData = {
          labels: this.categoryTable.map(
            (item: any) => item.conversation_category
          ),
          datasets: [
            {
              label: 'Category Distribution',
              data: this.categoryTable.map(
                (item: any) => item.count
              )
            }
          ]
        };
      });
  }

  onBarChartClick(event: { event?: ChartEvent; active?: any[] }): void {
    if (!event.active || event.active.length === 0) {
      return;
    }

    const index = event.active[0].index;
    const category = this.barChartData.labels?.[index];

    console.log('Selected category:', category);
  }



  formatDate(date: Date | string | null | undefined): string {
  if (!date) {
    return '';
  }

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) {
    console.warn('Invalid date passed to formatDate:', date);
    return '';
  }

  return parsedDate.toISOString().split('T')[0];
}

onTabChange(event: any) {
  this.activeTab = event.index === 0 ? 'stats' : 'activity';

  // Optional cleanup
 
}

ngOnChanges(changes: SimpleChanges) {
  if (changes['globalStartDate'] || changes['globalEndDate']) {
    this.startDate = this.globalStartDate;
    this.endDate = this.globalEndDate;
    this.fetchCategoryDistribution(); // Your existing fetch/load function
  }
}
}
